export default __webpack_public_path__ + "static/media/Vuejs.b87f6338.png";